import { createContext } from "react";

export const GlobalComponentsContext = createContext(undefined);
